import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Leaf } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? match[1] : null;

    if (!session_id) {
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id }, { withCredentials: true });
        setUser(r.data);
        window.history.replaceState({}, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: r.data } });
      } catch (e) {
        navigate('/', { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#faf7f1] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full bg-[#e8f2e2] mx-auto flex items-center justify-center animate-pulse">
          <Leaf className="w-7 h-7 text-[#3a5a2c]" />
        </div>
        <p className="mt-4 font-serif text-2xl text-[#1a2b17]">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
